import { useState } from "react";
import { toast } from "react-toastify";
import { updateProjectAssignment } from "../../apis/projectApi";

export const useUpdateProjectAssignment = () => {
  const [updateassignLoading, setUpdateLoading] = useState(false);
  const [updateError, setUpdateError] = useState(null);

  const extractError = (err) => {
    const res = err.response?.data;

    return {
      title: res?.message || "Update Failed",
      issue: res?.data || "Failed to update project assignment.",
    };
  };

  const updateAssignment = async (assignmentId, assignmentData) => {
    setUpdateLoading(true);
    setUpdateError(null);

    const toastId = toast.loading("Updating assignment...");

    try {
      const payload = {
        user: assignmentData.user,
        access_level: assignmentData.access_level,
        responsibilities: assignmentData.responsibilities?.trim() || null,
        start_date: assignmentData.start_date || null,
        end_date: assignmentData.end_date || null,
        remark: assignmentData.remark?.trim() || null,
      };

      const response = await updateProjectAssignment(assignmentId, payload);

      toast.update(toastId, {
        render: (
          <div>
            <strong>Assignment Updated</strong>
            <div>Surveyor assignment updated successfully.</div>
          </div>
        ),
        type: "success",
        isLoading: false,
        autoClose: 3200,
      });

      return response;

    } catch (err) {
      const { title, issue } = extractError(err);

      toast.update(toastId, {
        render: (
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        ),
        type: "error",
        isLoading: false,
        autoClose: 5500,
      });

      setUpdateError({ title, issue });
      throw err;

    } finally {
      setUpdateLoading(false);
    }
  };

  return {
    updateassignLoading,
    updateError,
    updateAssignment,
  };
};